<template>
    <div class="dropdown-container">
        <div class="dropdown"
            :class="{ 'dropdown-moded': isList(), 'dropdown-disabled': disabled || (this.onlyItemAutoSelect && this.items.length === 1) }">
            <div class="dropdown-selected form-control"
                :class="{ 'disabled': disabled || (this.onlyItemAutoSelect && this.items.length === 1), 'is-validate': isValidate }"
                v-if="!isList()" @click="open">
                <input v-show="isOpen && isSearch" type="text" v-model="searchField" ref="input" />
                <div v-if="!(isOpen && isSearch)">
                    <div v-if="isLoading && disabled" class="is-loading">
                        <transition name="fade" mode="out-in">
                            <div class="spinner"></div>
                        </transition>
                        <span>{{ $t('components.loading') }}</span>
                    </div>
                    <span v-else-if="selectedLabel && !isMultiple" v-html="selectedLabel"></span>
                    <span v-else-if="isMultiple && selectedValues.length">
                        {{ $t('components.selected') }}: {{ selectedValues.length }}
                    </span>
                    <span v-else class="not-selected">{{ notSelectedLabel }}</span>
                </div>
                <i class="dropdown-curret fa fa-sort-desc" aria-hidden="true"></i>
            </div>
            <div class="dropdown-list" :class="['dropdown-mode_' + mode, 'dropdown-style_' + dropdownStyle]"
                v-if="isOpen || isList()" v-on-click-outside="closeClickOutside">
                <div class="dropdown-list_item" :class="{
                    'is-selected': selectedValues.findIndex(value => value == item.value) !== -1 || (item.value === selectedValue),
                    'form-control': dropdownStyle !== 'simple'
                }" v-for="(item, index) in items" v-show="isList() || ((index < 300) && search(item))"
                    @click="select(item, index)">
                    <checkbox v-if="mode === 'checkbox'" ref="checkbox" />
                    <radio v-if="mode === 'radio'" ref="radio" :name="radioName"
                        :init-checked="item.value === selectedValue" :value="item.value"
                        @update="select(item, index)" />
                    <div v-if="dropdownStyle === 'simple' && isList()" v-html="translateItemLabel(item)"
                        @click="select(item, index, false)">
                    </div>
                    <div v-else v-html="translateItemLabel(item)"></div>
                </div>
            </div>
            <span class="dropdown-clear" v-if="isClearable && (selectedValues.length || selectedValue)"
                @click="clearSelected">❌</span>
        </div>
    </div>
</template>

<script>
import { vOnClickOutside } from '@vueuse/components'
import Checkbox from 'components/form/Checkbox.vue';
import Radio from 'components/form/Radio.vue';

export default {
    name: "Dropdown",
    directives: {
        onClickOutside: vOnClickOutside
    },
    components: {
        Checkbox, Radio
    },
    emits: ['update:modelValue', 'update:initItems', 'update', 'update:initDisabled'],
    props: {
        allItemValue: {
            default: 'all'
        },
        isAllItem: {
            type: Boolean,
            default: false
        },
        firstItemAutoSelect: {
            type: Boolean,
            default: false
        },
        onlyItemAutoSelect: {
            type: Boolean,
            default: false
        },
        notSelectedLabel: {
            type: String,
            default: 'Select value'
        },
        initDisabled: {
            type: Boolean,
            default: false
        },
        isLoading: {
            type: Boolean,
            default: false
        },
        initItems: {
            required: true,
            type: Array,
            default: () => []
        },
        modelValue: {
            default: null
        },
        isSearch: {
            type: Boolean,
            default: false
        },
        isMultiple: {
            type: Boolean,
            default: false
        },
        isClearable: {
            type: Boolean,
            default: false
        },
        mode: {
            type: String,
            default: 'default'
        },
        dropdownStyle: {
            type: String,
            default: 'dropdown'
        },
        translateKey: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            items: this.initItems,
            isOpen: false,
            selectedLabel: null,
            selectedValue: null,
            selectedValues: [],
            isValidate: false,
            disabled: this.initDisabled,
            searchField: '',
            radioName: ''
        }
    },
    methods: {
        clearSelected() {
            this.selectedLabel = null;
            this.selectedValue = null;
            this.selectedValues = [],
                this.isOpen = false;
            this.searchField = '';
        },
        isList() {
            return ['list', 'checkbox', 'radio'].indexOf(this.mode) !== -1;
        },
        closeClickOutside() {
            this.isOpen = false;
            this.searchField = '';
        },
        open() {
            if ((this.isOpen && this.isSearch) || this.disabled || this.onlyItemAutoSelect && this.items.length === 1)
                return;

            this.isOpen = !this.isOpen;
            if (this.isOpen && this.isSearch)
                this.$refs.input.focus();
        },
        select(item, i, notReturn = true) {
            if (this.dropdownStyle === 'simple' && this.isList() && notReturn)
                return false;

            if (!this.isMultiple) {
                this.selectedLabel = this.translateItemLabel(item);
                this.selectedValue = item.value;
                this.isOpen = false;
                this.searchField = '';
                this.$emit('update:modelValue', this.selectedValue);
                this.$emit('update', item);
            } else {
                let selectedValues = [...this.selectedValues];
                const index = selectedValues.findIndex(element => element == item.value);

                if (this.isAllItem && item.value === this.allItemValue) {
                    if (index === -1) {
                        selectedValues = [item.value];
                        this.$emit('update:modelValue', selectedValues);
                    } else {
                        selectedValues = [];
                        this.$emit('update:modelValue', []);
                    }
                    this.isOpen = false;
                } else {
                    if (index === -1) {
                        selectedValues.push(item.value);
                    } else {
                        selectedValues.splice(index, 1);
                    }
                    if (this.isAllItem && selectedValues.includes(this.allItemValue)) {
                        const allIndex = selectedValues.indexOf(this.allItemValue);
                        if (allIndex !== -1) {
                            selectedValues.splice(allIndex, 1);
                        }
                    }

                    this.$emit('update:modelValue', selectedValues);
                }

                if (this.mode === 'checkbox' && this.$refs.checkbox) {
                    this.$refs.checkbox.forEach((checkbox, index) => {
                        checkbox.setChecked(selectedValues.includes(this.items[index].value));
                    });
                }

                this.$emit('update', selectedValues);
            }
        },
        updateItems(items) {
            this.items = items;
            if (this.modelValue !== null) {
                if (this.isMultiple) {
                    this.setSelectedByValues(this.modelValue);
                } else {
                    this.setSelectedByValue(this.modelValue);
                }
            } else if (this.onlyItemAutoSelect && this.items.length === 1) {
                this.setSelectedByValue(this.items[0].value);
            } else if (this.firstItemAutoSelect && this.items.length) {
                this.setSelectedByValue(this.items[0].value);
            }
        },
        setSelectedByValue(itemValue) {
            const selectedItem = this.items.find(item => item.value == itemValue);
            if (selectedItem) {
                this.selectedValue = selectedItem.value;
                this.selectedLabel = this.translateItemLabel(selectedItem);
                this.$emit('update', selectedItem);
                this.$emit('update:modelValue', this.selectedValue);
            } else if (itemValue === null) {
                this.selectedValue = null;
                this.selectedLabel = null;
                this.$emit('update:modelValue', null);
                this.$emit('update', null);
            }
        },
        setSelectedByValues(values) {
            if (!Array.isArray(values)) {
                values = [];
            }
            this.selectedValues = values;

            if (values === "") {
                this.selectedValues = ['all'];
            }

        },
        search(item) {
            if (!this.isSearch || this.searchField == '')
                return true;
            return item.label.toLowerCase().indexOf(this.searchField.toLowerCase()) !== -1;
        },
        translateItemLabel(item) {
            if (this.translateKey) {
                return this.$t(this.translateKey + '.' + item.label);
            } else {
                return item.label;
            }
        }
    },
    mounted() {
        this.radioName = 'radio_' + this.$uid;
        if (this.modelValue !== null)
            this.setSelectedByValue(this.modelValue);
    },
    watch: {
        isOpen(newVal) {
            if (!this.isSearch)
                return false;

            const self = this;
            if (newVal)
                setTimeout(() => self.$refs.input.focus(), 100);
            else
                this.searchField = '';
        },
        modelValue(newVal, oldVal) {
            if (!this.isMultiple)
                this.setSelectedByValue(newVal);
            else
                this.setSelectedByValues(newVal);
        },
        initItems(newVal) {
            if (newVal.length > 0)
                this.disabled = false;
            this.updateItems(newVal)
        },
        initDisabled(newVal){
            console.log(newVal);
            this.disabled = newVal;
        }
    },
}
</script>

<style scoped>
.dropdown {
    position: relative;
}

.dropdown-selected {
    cursor: pointer;
    position: relative;
}

.dropdown-curret {
    position: absolute;
    right: 0.6rem;
    top: 0.5rem;
}

.dropdown-list {
    width: 100%;
    border: 1px solid var(--bs-gray-400);
    width: 100%;
    max-height: 280px;
    overflow: auto;
}

.dropdown:not(.dropdown-moded) .dropdown-list {
    position: absolute;
    border-top: none;
    z-index: 1;
}

.dropdown-moded .dropdown-list {
    border-radius: 0.25rem;
}

.not-selected {
    color: #9aa3a8;
}

.dropdown-list_item.form-control {
    border-radius: 0;
    cursor: pointer;
    border: none;
    position: relative;
}

.dropdown-list_item.form-control:hover {
    background: var(--bs-gray-200);
    color: var(--bs-gray-900);
}

.dropdown-list>.dropdown-list_item.form-control:last-child {
    border-radius: 0 0 0.25rem 0.25rem;
}

.invalid .dropdown-selected.form-control {
    border-color: #dc3545;
}

.dropdown-selected input[type="text"] {
    background: transparent;
    border: none;
    outline: none !important;
    max-width: 100%;
}

.dropdown-list_item.is-selected:after {
    content: "✔";
    position: absolute;
    right: 10px;
}

.dropdown-list_item {
    display: flex;
}

.dropdown-mode_checkbox .dropdown-list_item.is-selected:after {
    display: none;
}

.dropdown-style_simple {
    border: none;
    max-height: initial;
}

.dropdown-style_simple .dropdown-list_item {
    margin-bottom: 4px;
}

.dropdown-mode_radio.dropdown-style_simple {
    padding-left: 3px;
}

.dropdown-style_simple .dropdown-list_item>div {
    cursor: pointer;
}

.dropdown-disabled {
    opacity: .5;
}

.dropdown-disabled .dropdown-selected {
    cursor: no-drop;
}

.spinner {
    height: 10px;
    width: 10px;
    margin-right: 8px;
    opacity: 1;
    filter: alpha(opacity=100);
    animation: rotation .7s infinite linear;
    border: 4px solid rgba(0, 0, 0, 0.5);
    border-top-color: #9E9E9E;
    border-radius: 100%;
    transition: .3s all ease;

    display: inline-block;
}

.dark-mode .dropdown input {
    color: var(--bs-white) !important;
}

@keyframes rotation {
    from {
        transform: rotate(0deg)
    }

    to {
        transform: rotate(359deg)
    }
}

.dropdown-clear {
    font-size: 12px;
    position: absolute;
    right: 25px;
    top: 10px;
    cursor: pointer;
}
</style>
